import { filter } from "rxjs/operators";
/* Angular Component */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { UserService } from "../../domain/user-service";
import { DynamicScript } from "../../domain/dynamic-script";
import { Auth } from "../../infrastructure/auth";
import { UserRepository } from "../../domain/user-repository";
import { Logger } from "../../infrastructure/logger";
import { Channel } from "../../domain/channel";
import { NavigationEnd, Router } from "@angular/router";
import { UI } from "../../services/ui.service";
import { ShowRepository } from "../../domain/show-repository";
import { User } from "../../domain/user";
import {
  ClientReportsState,
  ReportsService,
} from "../../services/reports.service";
import { AlertsNotificationButtonComponent } from "../common/alerts-notification-button/alerts-notification-button.component";
import moment from "moment";
import { ConversionUtils } from "../../domain/conversion-utils";
import { UsersRepositoryImpl } from "../../infrastructure/repositories/user/user";
import { TenantService } from "../../services/tenant.service";
import { TenantSettings } from "../../domain/tenant-settings";
import { UserBrandingService } from "../../domain/user-branding-service";
import { BackofficeUserBrandingSettings } from "../../domain/user-branding";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Tenant } from "../../domain/tenant";
import { IContentControlRepository } from '../../domain/content-control/repository';
import { CensorshipReportEntry } from '../../domain/content-control/reporting';
import { ContentControlledEventActionEnum } from '../../domain/content-control/enums';
import { environment } from "app/environments/environment";

const MAX_INTEGER = 2147483647;
@Component({
  selector: "top-header",
  templateUrl: "./topHeader.component.html",
  styleUrls: ["./topHeader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopHeaderComponent implements OnInit {
  constructor(
    private ui: UI,
    private userService: UserService,
    private auth: Auth,
    private userRepository: UserRepository,
    private logger: Logger,
    private router: Router,
    private ref: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private showRepository: ShowRepository,
    private reportsService: ReportsService,
    private tenantService: TenantService,
    private _userBrandingService: UserBrandingService,
    private _ngxSmartModalService: NgxSmartModalService,
    private _contentControlRepository: IContentControlRepository,
  ) {}

  isDevelopment = environment.production === false;
  isUserHasCurrentChannel;

  showRecordingFeature = false;
  notInChannelDashboard = false;
  channel: Channel;

  animateOut = false;
  mouseLeaveActive = false;
  selectedFullSegmentReportFormat: "FPS" | "MS" = "FPS";
  processingCensorshipAiReport: boolean = false;

  censorshipAiReportVideoIdPatternField = '';
  selectedCensorshipAiReportType: "OnlySummary" | "SummaryPerItem" | "Detailed" = "OnlySummary";
  censorshipAiReportFromTimeField: moment.Moment;
  censorshipAiReportToTimeField: moment.Moment;

  isLive = false;
  showLiveButton = false;
  userBrandingSettings: BackofficeUserBrandingSettings;

  managedTenantFilter = "";
  userMangedTenants: Tenant[];

  @Input()
  systemWorkingIndicatorStatus;

  @Output() openChannelPreview = new EventEmitter<Channel>();

  @ViewChild(AlertsNotificationButtonComponent) alertsNotificationButtton;

  currentUser: User;

  appName = "";

  /* Top Header Links */
  links = [
    { name: "Scheduler", link: "scheduler/calendar" },
    { name: "Autopilot", link: "autopilot" },
    // {name: "Playout", link: "playout"},
    // {name: "Analytics", link: "analytics"}
  ];
  showUserAlertsMenu = false;
  showProfileMenu: boolean;
  reportAlertsCounter: number;
  isTrialUser = false;
  trialDaysLeft: number;

  @ViewChild("managedTenantFilterElement")
  managedTenantFilterElement: ElementRef;

  /**
   * Mouse Leave menu handler - closing automatically the menu
   * @return void
   */ CreateDynamicPromoShow;
  isMenuOpen = () => {
    return this.showProfileMenu;
  };

  getUsername() {
    return this.currentUser.username;
  }

  getUserDynamicScripts() {
    return this.currentUser.dynamicScripts.filter(
      (x) => x.showScriptOnTopRight,
    );
  }

  onDynamicScriptClick(script: DynamicScript) {
    window.open(script.url);
  }

  logout() {
    //this.auth.remove();
    this.auth.remove();
    window.localStorage.clear();
    window.location.href = "/login";
  }

  /**
   * Handler for menu toggle
   * @param event
   * @return void
   */
  profileMenuToggle(event) {
    this.animateOut = true;
    event.preventDefault();

    this.forceTopMenuClose();
    this.showProfileMenu = !this.showProfileMenu;
    this.animateOut = false;
  }

  toggleUserAlertsMenu(event) {
    event.preventDefault();

    this.forceTopMenuClose();
    this.showUserAlertsMenu = !this.showUserAlertsMenu;
    this.animateOut = false;
  }

  public getFullMediaReport() {
    this.reportsService.getFullMediaReport();
  }
  public getMediaMetadataReport() {
    this.reportsService.getMediaMetadataReport();
  }

  /**
   * Return full name and fallback to username
   * @return {string}
   */
  getFullName() {
    return (this.currentUser && this.currentUser.getFullName()) || "";
  }

  /**
   * Return the First Letter in Username
   * @return {string}
   */
  getFirstChartInUsername() {
    if (this.currentUser) {
      let name = this.currentUser.firstName;

      if (name == null || name.length == 0 || !name) {
        name = this.getUsername();
      }

      return name.charAt(0).toUpperCase();
    }
    return "";
  }

  /**
   * Return email to view
   * @return string
   */
  getUserEmail() {
    if (this.currentUser) {
      const email = this.currentUser.email;

      if (email == null || email.length == 0 || !email) {
        return this.getUsername();
      }

      return email;
    }
    return "";
  }

  /**
   * Forcing top menu close
   * @return void
   */
  forceTopMenuClose() {
    if (this.isMenuOpen()) {
      this.animateOut = true;

      setTimeout(() => {
        this.animateOut = false;
        this.showProfileMenu = false;
        // this.showUserAlertsMenu = false;
        this.changeDetectorRef.markForCheck();
      }, 250);
    }
  }
  mouseLeaveHandler() {
    this.mouseLeaveActive = true;

    setTimeout(() => {
      if (this.isMenuOpen() && this.mouseLeaveActive) {
        this.forceTopMenuClose();
        this.mouseLeaveActive = false;
      }
    }, 2500);
  }

  /**
   * Mouse enter handler
   * @return void
   */
  mouseEnterHandler() {
    this.mouseLeaveActive = false;
  }

  /**
   *
   */
  async ngOnInit() {
    this.userBrandingSettings =
      await this._userBrandingService.getUserBrandingSettings();
    this.ui.listen(
      this.ui.EVENTS.CloseTopMenu,
      this.forceTopMenuClose.bind(this),
    );

    const topHeaderElement = this.ref.nativeElement;
    const menuElements = topHeaderElement.querySelectorAll(".menu");
    this.currentUser = this.userService.getCurrentUser();

    if (this.currentUser.isSuperUser) {
      this.links.push({ name: "Live", link: "live" });
    }
    this.isTrialUser = this.currentUser.trialEndsDate != null;
    // this.isTrialUser = true;
    if (this.isTrialUser) {
      this.listenToTrialEndedEvent();
    }

    menuElements.forEach((menuElement) => {
      menuElement.addEventListener(
        "mouseleave",
        this.mouseLeaveHandler.bind(this),
        false,
      );
      menuElement.addEventListener(
        "mouseenter",
        this.mouseEnterHandler.bind(this),
        false,
      );
    });

    this.userService.getCurrentChannel().then((result) => {
      this.isUserHasCurrentChannel =
        !!result && result.name && result.name.length > 0;
      if (this.isUserHasCurrentChannel) {
        this.channel = result;
      }
    });

    this.userService.currentChannelIdUpdated.subscribe((channelId) => {
      if (channelId) {
        this.isUserHasCurrentChannel = true;
        this.userService.getCurrentChannel().then((result) => {
          this.channel = result;
        });
      }
    });
    this.tenantService.getTenantSettings().then((settings: TenantSettings) => {
      this.showRecordingFeature =
        settings.AllowRecordingFeature &&
        this.currentUser.hasRecordingPermission;
    });

    /* Tracking Route Changes */
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = (<NavigationEnd>event).url;

        /* Show Hide Top Header */
        this.notInChannelDashboard =
          url.indexOf("/channels") === -1 && url.indexOf("/recording") === -1;

        if (url.indexOf("/live") !== -1) {
          this.showLiveButton = true;
        } else {
          this.showLiveButton = this.isLive;
        }
      });

    /* Changing the isLive flag */
    this.ui.EVENTS.LiveStatusDidChange.subscribe((isLive) => {
      this.isLive = !!isLive;

      if (this.router.url.indexOf("/live") === -1) {
        this.showLiveButton = this.isLive;
      }
    });

    this.reportsService.reportsGlobalState.subscribe((newState) => {
      this.reportAlertsCounter = this.localReportsReducer(newState);
    });
    this.changeDetectorRef.markForCheck();
  }

  localReportsReducer(globalState: ClientReportsState): number {
    let newLocalState = 0;

    if (
      globalState.reportAlertsSettings &&
      globalState.reportAlertsSettings.gapsReportEnabled
    ) {
      newLocalState += globalState.gapsCount;
    }

    if (
      globalState.reportAlertsSettings &&
      globalState.reportAlertsSettings.missingSubtitleReportEnabled
    ) {
      newLocalState += globalState.missingSubtitlesCount;
    }

    if (
      globalState.reportAlertsSettings &&
      globalState.reportAlertsSettings.missingAudiosReportEnabled
    ) {
      newLocalState += globalState.missingAudiosCount;
    }

    if (
      globalState.reportAlertsSettings &&
      globalState.reportAlertsSettings.emptyContractReportEnabled
    ) {
      newLocalState += globalState.emptyContractCount;
    }

    return newLocalState;
  }

  updatePlayout() {
    this.userService.getCurrentChannel().then((channel) => {
      this.showRepository.updatePlayout(channel.id).then((res) => {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Update Playout",
          message: "updated playout successfully",
        });
      });
    });
  }

  private calculateTrialDaysLeft(trialEndsDate: Date) {
    console.log("calculateTrialDaysLeft -> trialEndsDate", trialEndsDate);
    const currentDate: Date = ConversionUtils.convertToUTC(new Date());
    console.log("calculateTrialDaysLeft -> currentDate", currentDate);
    const diffMilliseconds = trialEndsDate.valueOf() - currentDate.valueOf();
    if (diffMilliseconds > 0) {
      return ConversionUtils.convertMiliseconds(diffMilliseconds, "d") + 1;
    } else {
      return 1;
    }
  }

  private setTimeoutToDisconnectUser(milliseconds: number) {
    console.log(
      "Trial period will be ended in " +
        Math.floor(milliseconds / 1000) +
        " secs",
    );

    let waitingTimeout = milliseconds;
    if (milliseconds > MAX_INTEGER) {
      // cannot use timeout bigger than MAX_INTEGER
      waitingTimeout = MAX_INTEGER;
    }
    const timeOut = setTimeout(() => {
      console.log("Trial period has expired. Logging out...");
      this.logout();
    }, waitingTimeout);

    return timeOut;
  }

  private listenToTrialEndedEvent() {
    let disconnectTimeout = null;

    const intervalFn = () => {
      if (disconnectTimeout != null) {
        clearInterval(disconnectTimeout);
      }

      // run every 10 minute and refresh the current user cache
      (this.userRepository as UsersRepositoryImpl).init().then(() => {
        this.currentUser = this.userService.getCurrentUser();

        this.trialDaysLeft = this.calculateTrialDaysLeft(
          this.currentUser.trialEndsDate,
        );
        const delta =
          this.currentUser.trialEndsDate.valueOf() -
          ConversionUtils.convertToUTC(new Date()).valueOf();

        if (delta > 0) {
          disconnectTimeout = this.setTimeoutToDisconnectUser(delta);
        } else {
          console.log("logging out");
          this.logout();
        }
      });
    };
    intervalFn();
    setInterval(intervalFn, 600000);
  }

  switchTenantClickedEventHandler() {
    this.userMangedTenants = [...this.currentUser.managedTenants];
    this._ngxSmartModalService.getModal("switchTenantPopupModal").open();
    this.managedTenantFilter = "";

    setTimeout(() => {
      this.managedTenantFilterElement.nativeElement.focus();
    });
    this.changeDetectorRef.markForCheck();
  }

  switchToTenant(tenant: Tenant) {
    console.log("top-Header->switchToTenant", tenant);
    this.userRepository
      .changeTenant(tenant.id)
      .then(() => {
        return this.userRepository.refreshAccessToken();
      })
      .then((newToken) => {
        this.auth.token = newToken;

        this.router.navigateByUrl("channels").then(() => {
          window.location.replace(location.pathname);
        });
      });
  }

  managedTenantFilterChangedEventHandler(filterTerm: string) {
    this.userMangedTenants = this.currentUser.managedTenants.filter((t) =>
      t.name.toLowerCase().trim().includes(filterTerm.toLowerCase().trim()),
    );
    this.changeDetectorRef.markForCheck();
  }

  showFullSegmentsReportPopup() {
    this.selectedFullSegmentReportFormat = "FPS";
    this._ngxSmartModalService
      .getModal("exportFullSegmentsReportPopupModal")
      .open();
  }

  showCensorshipAiReportPopup() {
    //Reset fields
    this.selectedCensorshipAiReportType = "OnlySummary";
    this.censorshipAiReportVideoIdPatternField = '';
    this.censorshipAiReportFromTimeField =  moment.utc().subtract(24, 'hours');
    this.censorshipAiReportToTimeField = moment.utc();

    this._ngxSmartModalService
      .getModal("exportCensorshipAiReportPopupModal")
      .open();
  }

  downloadFullSegmentReport() {
    console.log(
      "top-header->downloadFullSegmentReport",
      this.selectedFullSegmentReportFormat,
    );
    const timeCodeFormat =
      this.selectedFullSegmentReportFormat === "FPS" ? 0 : 1;
    this.reportsService.getFullSegmentsReport(timeCodeFormat).then();
  }

  async downloadCensorshipAiReport() {
    console.log(
      "top-header->downloadCensorshipAiReport",
      this.selectedCensorshipAiReportType,
    );
    this.processingCensorshipAiReport = true;
    const censorshipReportEntries = await this._contentControlRepository.getCensorshipAiReport(this.censorshipAiReportVideoIdPatternField, this.censorshipAiReportFromTimeField, this.censorshipAiReportToTimeField);
    const reportCsvRow = this._mapCensorshipAiReportToCsvRows(censorshipReportEntries, this.selectedCensorshipAiReportType);
    this._exportCensorshipAiReportToCsv(reportCsvRow, `censorship-ai-report_${this.censorshipAiReportVideoIdPatternField}_${this.selectedCensorshipAiReportType}_(${this.censorshipAiReportFromTimeField.format("YYYY-MM-DDTHH:mm:ss")}_${this.censorshipAiReportToTimeField.format("YYYY-MM-DDTHH:mm:ss")}).csv`);

    this.processingCensorshipAiReport = false;
  }

  changeReportFormat(format: "FPS" | "MS") {
    console.log("top-header->changeReportFormat", format);
    this.selectedFullSegmentReportFormat = format;
  }

  changeCensorshipAiReportType(type: "OnlySummary" | "SummaryPerItem" | "Detailed") {
    console.log("top-header->changeCensorshipAiReportType", type);
    this.selectedCensorshipAiReportType = type;
  }
  private _mapCensorshipAiReportToCsvRows(reportEntries: CensorshipReportEntry[], reportType: "OnlySummary" | "SummaryPerItem" | "Detailed"): CensorshipAiReportCsvRow[] {
    const result: CensorshipAiReportCsvRow[] = [];
    let detailedSummary: CensorshipAiReportSummary = CensorshipAiReportSummary.empty();
    for(const entry of reportEntries) {
      const itemCsvRows: CensorshipAiReportCsvRow[] = [];
      const mergedEvents = entry.mergedEvents;
      for (const mergedEvent of mergedEvents) {
        const eventDurationMoment = moment.duration(mergedEvent.endsAtMs - mergedEvent.startsAtMs, 'milliseconds');

        itemCsvRows.push(new CensorshipAiReportCsvRow(entry.tenantMediaUniqueId, this._durationToFormattedTC(moment.duration(mergedEvent.startsAtMs, 'milliseconds'), entry.mediaFps), this._durationToFormattedTC(eventDurationMoment, entry.mediaFps), mergedEvent.eventType, mergedEvent.actionDisplayName));
      }

      result.push(...itemCsvRows);
      if (itemCsvRows.length > 0) {
        let itemSummary: CensorshipAiReportSummary = CensorshipAiReportSummary.empty().fillFromCsvRows(itemCsvRows);
        result.push(...itemSummary.toCsvRows(true));

        detailedSummary.makeAdditionWith(itemSummary);
      }

    }

    if (reportType === "OnlySummary") {
      result.length = 0;
    }

    if (reportType !== "SummaryPerItem") {
      result.push(...detailedSummary.toCsvRows(false));
    }

    return result;
  }

  private _durationToFormattedTC(
    inputDuration: moment.Duration,
    mediaFps: number,

  ): string {
    const rowFps = ConversionUtils.getFpsFromMs(
      inputDuration.milliseconds(),
      mediaFps,
    );
    const padFps = this._padFps(rowFps, mediaFps);

    return (
      moment.utc(inputDuration.asMilliseconds()).format("HH:mm:ss") + padFps
    );
  }
  private _padFps(rowFps: number, mediaFps: number) {
    return rowFps < 10 ? ".0" + rowFps : "." + (rowFps % mediaFps);
  }

  private _exportCensorshipAiReportToCsv(rows: CensorshipAiReportCsvRow[], fileName: string = 'censorship-ai-report.csv') {
    //this code generated by ChatGPT
    if (!rows) {
      console.error('No data to export.');
      return;
    }

    const headers = Object.keys(new CensorshipAiReportCsvRow('','','','','')).join(',');
    const csvRows = rows.map(row =>
      Object.values(row)
        .map(value => `"${String(value).replace(/"/g, '""')}"`) // Escape quotes
        .join(',')
    );

    const csvContent = [headers, ...csvRows].join('\r\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
class CensorshipAiReportSummary {
  constructor(
    public positivesByType:  { [key: string]: number } = {},
    public falsePositivesByType:  { [key: string]: number } = {},
    public falseNegatives: number = 0,
    public undecided: number = 0) {
  }
  public makeAdditionWith(other: CensorshipAiReportSummary): CensorshipAiReportSummary {
    const otherPositivesEventTypes = Object.keys(other.positivesByType);
    for (const otherPositivesEventType of otherPositivesEventTypes) {
      this.positivesByType[otherPositivesEventType] = (this.positivesByType[otherPositivesEventType] || 0) + other.positivesByType[otherPositivesEventType];
    }
    const otherFalsePositivesEventTypes = Object.keys(other.falsePositivesByType);
    for (const otherFalsePositivesEventType of otherFalsePositivesEventTypes) {
      this.falsePositivesByType[otherFalsePositivesEventType] = (this.falsePositivesByType[otherFalsePositivesEventType] || 0) + other.falsePositivesByType[otherFalsePositivesEventType];
    }

    this.falseNegatives += other.falseNegatives;
    this.undecided += other.undecided;
    return this;
  }
  public static empty(): CensorshipAiReportSummary {
    return new CensorshipAiReportSummary({}, {}, 0);
  }

  public fillFromCsvRows(csvRows: CensorshipAiReportCsvRow[]): CensorshipAiReportSummary {
    for(const csvRow of csvRows) {
      if (csvRow.isFalsePositive()){
        this.falsePositivesByType[csvRow.Detection] = (this.falsePositivesByType[csvRow.Detection] || 0) + 1;
      } else if (csvRow.isPositive()){
        this.positivesByType[csvRow.Detection] = (this.positivesByType[csvRow.Detection] || 0) + 1;
      } else  if (csvRow.isFalseNegative()){
        this.falseNegatives++;
      } else {
        this.undecided++;
      }
    }

    return this;
  }
  public toCsvRows(isItemSummary: boolean):CensorshipAiReportCsvRow[] {
    const result: CensorshipAiReportCsvRow[] = [];

    if (isItemSummary === false){
      result.push(CensorshipAiReportCsvRow.empty());
    }

    result.push(new CensorshipAiReportCsvRow('', "", isItemSummary? "Item Summary:": "Report Summary", "", ""));

    const positivesEventTypes = Object.keys(this.positivesByType);
    for(let i = 0; i < positivesEventTypes.length; i++) {
      const eventType = positivesEventTypes[i];

      result.push(new CensorshipAiReportCsvRow('', "", "", i === 0? "Positives By Type:": "", `${eventType}: ${this.positivesByType[eventType]}`));
    }

    const falsePositivesEventTypes = Object.keys(this.falsePositivesByType);
    for(let i = 0; i < falsePositivesEventTypes.length; i++) {
      const eventType = falsePositivesEventTypes[i];

      result.push(new CensorshipAiReportCsvRow('', "", "", i === 0? "False Positive by type:": "", `${eventType}: ${this.falsePositivesByType[eventType]}`));
    }

    result.push(new CensorshipAiReportCsvRow('', "", "",  "False Negatives:", `${this.falseNegatives}`));
    result.push(new CensorshipAiReportCsvRow('', "", "",  "Undecided:", `${this.undecided}`));

    result.push(CensorshipAiReportCsvRow.empty());
    return result;
  }

}
class CensorshipAiReportCsvRow {
  constructor(
    public ItemID: string,
    public TimeInItem: string,
    public Duration: string,
    public Detection: string,
    public UserAction: string) {
  }

  public isFalseNegative(): boolean {
    return this.Detection === '' && this.UserAction !== '';
  }

  public isPositive(): boolean {
    return this.Detection !== '' && this.UserAction !== '';
  }
  public isFalsePositive(): boolean {
    return this.Detection !== '' && this.UserAction === ContentControlledEventActionEnum[ContentControlledEventActionEnum.Approve];
  }

  public static empty(): CensorshipAiReportCsvRow {
    return new CensorshipAiReportCsvRow("", "", "", "", "");
  }
}
